<!-- 主页面 -->
<template>
  <div class="main">
    <div class="reward f-center">
      <TxImage src="tu" class="tu" />
      <div class="end-time t-center">
        <span>{{ get_time_year_month_day(product_end_time * 1000) }}</span>
        停止抢购
      </div>
      <TxContainer src="bg2" class="f-column">
        <div class="f-row f-zhu-center m-30 buy">
          当前可购买礼包服务器
          <TxContainer
            src="kuang"
            class="m-l-20 p-l-10 server-color"
            @click="is_show_server = true"
          >
            {{ server[test_server_id] }}
          </TxContainer>
        </div>
        <div class="w-100 f-row f-zhu-center m-t-30">
          <TxImage src="tequan1" />
          <TxImage src="tequan2" />
        </div>
        <TxImage src="tu_3" class="m-t-20" />
        <div class="w-100 f-row f-zhu-center">
          <TxImage src="tequan3" />
          <TxImage src="tequan4" />
          <TxImage src="tequan5" />
        </div>
        <div class="f-center w-100 m-t-30">
          <TxButton
            src="btn1"
            name="点击购买"
            v-if="status !== 4 && !product_discount.includes(test_server_id)"
            @click="handle_start_buy"
          ></TxButton>
          <TxButton
            src="discount"
            name="点击购买"
            v-else-if="
              status !== 4 && product_discount.includes(test_server_id)
            "
            @click="handle_start_buy"
          ></TxButton>

          <TxImage src="btn2" v-else />
          <div>
            <span @click="handle_open_order" class="m-t-5 dingdan"
              >查看订单</span
            >
            <span @click="get_order_list" class="m-t-5 m-l-20 dingdan"
              >我已支付</span
            >
          </div>
        </div>
      </TxContainer>
    </div>
    <footer>
      <h3>购买说明</h3>
      <p>
        1 .新服特权礼包无需创建角色即可直接购买，每个账号在每个服务器限购一次
      </p>
      <p>
        2
        .购买成功后，绿色通道排队特权即刻生效。该特权以账号为单位生效，账号下所有角色均可享受排队特权
      </p>
      <p>3 .购买成功后，云游戏时间即刻生效</p>
      <p>
        4 .礼包内含的时装和珍兽奖励，需创角进入游戏后领取，每个账号仅限领取 1 次
      </p>
      <p>
        5 .自动任务权益对账号下所有角色生效，拥有该权益可无视 1
        万人物修为要求，在万象客户端直接自动完成师门、快马加鞭、诗与酒、童趣等日常任务
      </p>
      <p>6 .该礼包为天下贰经典版公测开服特惠礼，时装和坐骑永不返场，限时售卖</p>
    </footer>

    <!-- 确认支付的窗口 -->
    <TxDialog v-model="dialog.step_1" :closeOnClickOverlay="false">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">确认账号</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips">
            购买后解锁【{{ server[test_server_id] }}】新服特权礼包<br />
            享 <span class="lvtong">登录绿通特权,</span>优先进服
          </div>
        </div>

        <div class="f-center p-r dialog-footer">
          <TxButton src="goumai" name="确认购买" @click="handle_buy_step_2" />
          <span name="我在想想" class="think" @click="dialog.step_1 = false"
            >我再想想</span
          >
        </div>
      </TxContainer>
    </TxDialog>
    <!-- 选择支付方式 -->
    <TxDialog v-model="dialog.step_2" :closeOnClickOverlay="false">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">支付订单</div>
        <div class="dialog-content f-center">
          <span
            v-if="!product_discount.includes(test_server_id)"
            class="product_price"
            >¥{{ product_price }}</span
          >
          <span v-else class="product_price">¥{{ server_discount_price }}</span>

          <TxButton
            src="weixin"
            class="m-t-40"
            name="微信支付"
            @click="throttledClick('weixinpay')"
          />
          <TxButton
            src="zhifubao"
            class="m-t-20"
            name="支付宝购买"
            @click="throttledClick('alipay')"
          />
        </div>
        <div class="f-center p-r dialog-footer">
          <span class="back" @click="handle_step_2_1">返回上一步</span>
        </div>
      </TxContainer>
    </TxDialog>
    <!-- 支付成功 -->
    <TxDialog v-model="dialog.step_3">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">支付订单</div>
        <div class="dialog-content f-center p-r">
          <TxImage src="zi" />
          订单刷新稍有延迟<br />
          <span
            >请在<span class="server-color m-10">1分钟后</span
            >,查看订单状态</span
          >
        </div>
        <div class="f-center p-r dialog-footer">
          <TxButton
            src="queren"
            name="确认（支付成功关闭）"
            @click="handle_close"
          />
        </div>
      </TxContainer>
    </TxDialog>
    <!-- 订单信息 -->
    <TxDialog v-model="dialog.step_4">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">购买信息</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips f-row">
            <div class="order-left f-column">
              <span>新服特权礼包</span>
              <span>{{ order_time }}</span>
            </div>
            <div class="t-center m-l-20">
              <span v-if="status == 4" class="green">支付成功</span>
              <span v-else-if="status == 0" class="red">待支付</span>
              <span v-else-if="status == 1" class="green">正在支付</span>
              <span v-else class="red">支付失败</span>
            </div>
          </div>
        </div>

        <div class="f-center p-r dialog-footer">
          <TxButton
            src="queren"
            name="关闭订单"
            @click="dialog.step_4 = false"
          />
        </div>
      </TxContainer>
    </TxDialog>
    <TxDialog v-model="dialog.step_6">
      <TxContainer src="tanchuang" class="f-center">
        <div class="dialog-tips p-l-40">继续付款</div>
        <div class="dialog-content f-center">
          <div class="f-row item">
            <div>通行证</div>
            <div class="dialog-name t-center">{{ user.activeUrs }}</div>
          </div>
          <div class="f-row item">
            <div>服务器</div>
            <div class="dialog-server t-center server-color">
              {{ server[test_server_id] }}
            </div>
          </div>
          <div class="tips">
            购买后解锁【{{ server[test_server_id] }}】新服特权礼包<br />
            享 <span class="lvtong">登录绿通特权,</span>优先进服
          </div>
        </div>
        <div class="f-center p-r dialog-footer">
          <TxButton name="继续支付" @click="handle_continue_pay" src="goumai" />
          <span class="pay-has" @click="get_order_list">我已支付</span>
        </div>
      </TxContainer>
    </TxDialog>

    <template v-if="server_list">
      <nut-popup v-model:visible="is_show_server" position="bottom">
        <nut-picker
          :three-dimensional="true"
          :columns="server_list"
          title=" "
          @cancel="is_show_server = false"
          @confirm="server_confirm"
        />
      </nut-popup>
    </template>
  </div>
</template>

<script setup>
import eventEmitter from '@utils/event';
const { user, channel } = inject('GlobalStore');
import { onMounted, reactive, shallowRef } from 'vue';
import { useThrottleFn } from '@vueuse/core';
import { firstLog } from '../utils/log';
import { get_server_list } from '../utils/api';
import { get_time_year_month_day } from '../utils/time';
import getQueryParams from '../utils/getQueryParams';
import getUrlByParams from '../utils/getUrlByParams';

const project = 'tx2_oldclassic';
const h5_tag = 50;
let test_server_id = ref('');
const status = shallowRef(null);
class JellyOrderStatus {
  static INIT = 0;
  static ON_PAY = 1;
  static TIMEOUT = 2;
  static PAY_FAIL = 3;
  static PAY_SUCCESS = 4;
}
// 订单状态
const product_id = shallowRef('g20.jd.lstd.1005610');
const product_price = shallowRef(null);
const order_id = shallowRef(null);
const order_time = shallowRef(null);
const product_end_time = shallowRef(null);
const product_discount = ref([]);
const server_discount_price = shallowRef(null);

const dialog = reactive({
  step_1: false,
  step_2: false,
  step_3: false,
  step_4: false,
  step_6: false,
});

const server = {};

let server_list = ref(null);

function handlerPayGetProductList(project, h5_tag, server_id) {
  window.h5sdk.core
    .PayGetProductList(project, h5_tag, server_id)
    .then((res) => {
      if (res.code === 1) {
        product_id.value = res.data[0].productid;
        product_price.value = res.data[0].price;
        product_end_time.value = res.data[0].sale_end;
        product_discount.value = res.data[0].discounted_serverlist;
        server_discount_price.value = res.data[0].server_discount_price;
      } else {
        console.error('查询商品失败：', res);
      }
    });
}

function handle_start_buy() {
  if (user.value.isLoggedIn) {
    if (status.value == 0) {
      dialog.step_6 = true;
    } else {
      dialog.step_1 = true;
    }
  } else {
    eventEmitter.emit('login');
  }
}
function handle_buy_step_2() {
  if (channel.channel == 'wx') {
    throttledClick('weixinpay');
  } else {
    dialog.step_1 = false;
    dialog.step_2 = true;
  }
}

function handle_step_2_1() {
  dialog.step_2 = false;
  dialog.step_1 = true;
}

async function handle_pay(pay_method) {
  let pay_mode = 'h5';
  if (channel.channel == 'wx') {
    pay_mode = 'jsapi';
  }
  console.log(pay_method, pay_mode);

  // 计算每次传的页面参数
  let sale_server_id = getQueryParams()['sale_server_id'];
  let extra = getQueryParams()['extra'];
  let url = getUrlByParams({ sale_server_id: sale_server_id, extra: extra });
  console.log(sale_server_id, extra, url);
  let price = product_price.value;
  if (product_discount.value.includes(test_server_id.value)) {
    price = server_discount_price.value;
  }

  window.h5sdk.core
    .PayCreateOrder(
      {
        project: project,
        urs: user.value.activeUrs,
        account_id: user.value.activeUrsAccount.account,
        productid: product_id.value,
        product_price: price,
        product_count: 1,
        role_id: '',
        rolename: '',
        server_id: test_server_id.value,
        server_name: '',
        pay_method: pay_method,
        pay_mode: pay_mode,
      },
      url
    )
    .then((res) => {
      console.log('创建订单成功：', res);
    });
}
const throttledClick = useThrottleFn(handle_pay, 1000);

// 查询自己身上的订单
async function get_order_list() {
  let res = await window.h5sdk.api.h5PayOrdersList({
    project: 'tx2_oldclassic',
    h5_tag: h5_tag,
    page: 1,
    page_size: 1,
    productid: product_id.value,
    status_in: [0, 1, 4],
    sort: 'status',
    server_id: test_server_id.value,
  });
  if (res.code === 1) {
    let data = res.data.orders;
    if (data.length > 0) {
      status.value = data[0].status;
      order_id.value = data[0].id;
      order_time.value = data[0].create_time;
      if (
        status.value === JellyOrderStatus.INIT ||
        status.value === JellyOrderStatus.ON_PAY
      ) {
        // 查询是否为支付返回进入H5页面
        const returnPayParams = window.h5sdk.core.PayGetReturnPayParams();
        console.log('支付返回：' + JSON.stringify(returnPayParams));
        if (!returnPayParams) {
          if (status.value == 0) {
            dialog.step_6 = true;
          }
          if (status.value === JellyOrderStatus.ON_PAY) {
            window.h5sdk.core.PayWait(order_id.value).then((res) => {
              console.log('PayWait', res);
              if (!res.data) {
                if (status.value == 0) {
                  dialog.step_6 = true;
                }
              }
              order_id.value = res.data.order_id;
              status.value = res.data.status;
              order_time.value = res.data.create_time;
              if (status.value === JellyOrderStatus.PAY_SUCCESS) {
                dialog.step_3 = true;
              }
            });
          }
          return;
        }
        // 去查询支付状态
        window.h5sdk.core.PayWait(returnPayParams.order_id).then((res) => {
          if (!res.data) {
            if (status.value == 0) {
              dialog.step_6 = true;
            }
            return;
          }
          order_id.value = res.data.order_id;
          status.value = res.data.status;
          order_time.value = res.data.create_time;
          if (status.value === JellyOrderStatus.PAY_SUCCESS) {
            dialog.step_3 = true;
          }
        });
      }
      if (status.value == 4) {
        dialog.step_3 = true;
      }
    } else {
      status.value = null;
      order_id.value = null;
      order_time.value = null;
    }
  }
}

function start_query_pay() {
  window.h5sdk.core.QueryPayStatus(order_id.value).then((res) => {
    if (res.code === 1) {
      status.value = res.data.status;
    }
  });
}
async function handle_continue_pay() {
  await start_query_pay();
  if (status.value == 0) {
    // 走付款逻辑，不需要下订单
    window.h5sdk.core.PayRetryPayment(order_id.value);
    return;
  }
}

async function onVisible() {
  console.log('返回visible', window.location.href);
  const returnPayParams = window.h5sdk.core.PayGetReturnPayParams();
  console.log('returnPayParams', returnPayParams);
  if (!returnPayParams) return;
  if (status.value == 0) {
    dialog.step_6 = true;
  }
  window.h5sdk.core.PayWait(returnPayParams.order_id).then((res) => {
    console.log('PayWait', res);
    if (!res.data) return;
    order_id.value = res.data.order_id;
    status.value = res.data.status;
    order_time.value = res.data.create_time;
    if (status.value === JellyOrderStatus.PAY_SUCCESS) {
      dialog.step_2 = false;
      dialog.step_3 = true;
      dialog.step_6 = false;
    }
  });
}

function handle_close() {
  dialog.step_3 = false;
  dialog.step_6 = false;
  dialog.step_2 = false;
  dialog.step_1 = false;
  eventEmitter.emit('launch');
}

onMounted(async () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      console.log('返回visible');
      onVisible();
    }
  });
  const res = await get_server_list('tx2_oldclassic', h5_tag);
  if (res.code == 1) {
    let columns = [];
    res.data.forEach((element) => {
      server[element.server_id] = element.server_name;
      columns.push({
        text: element.server_name,
        value: element.server_id,
      });
    });
    server_list.value = columns;
    test_server_id.value = window.h5sdk.core.getEnterPaySaleServerId();
    if (!test_server_id.value) {
      test_server_id.value = server_list.value[0].value;
    }
    handlerPayGetProductList(project, h5_tag, test_server_id.value);
  } else {
    eventEmitter.emit('toast', {
      text: '查询服务器失败，请重试！',
    });
  }
});

async function handle_open_order() {
  let res = await window.h5sdk.api.h5PayOrdersList({
    project: 'tx2_oldclassic',
    h5_tag: h5_tag,
    page: 1,
    page_size: 1,
    productid: product_id.value,
    status_in: [0, 1, 4],
    sort: 'status',
    server_id: test_server_id.value,
  });
  if (res.code == 1) {
    let data = res.data.orders;
    if (data.length > 0) {
      status.value = data[0].status;
      order_id.value = data[0].id;
      order_time.value = data[0].create_time;
      dialog.step_4 = true;
    } else {
      eventEmitter.emit('toast', {
        text: '当前没有订单，请少侠先购买礼包',
      });
    }
  }
}

watch(user, (v) => {
  if (v.isLoggedIn) {
    get_order_list();
    firstLog(true);
  } else {
    firstLog(false);
  }
});

watch(test_server_id, (v) => {
  if (user.value.isLoggedIn) {
    get_order_list();
  }
});

// 选取服务器列表
let is_show_server = ref(false);
async function server_confirm({ selectedValue }) {
  test_server_id.value = selectedValue[0];
  is_show_server.value = false;
  window.h5sdk.core.setEnterPaySaleServerId(test_server_id.value);
  if (user.value.isLoggedIn) {
    get_order_list();
  }
}
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  @include bg('bg');
  height: var(--fullHeight) !important;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 20px;
}

.reward {
}

.launcher {
  position: absolute;
  right: 30px;
  top: 330px;
}

.btn-tips {
  position: absolute;
  right: 200px;
  top: -15px;
}

.dialog-tips {
  width: 100%;
  height: 40px;
  color: white;
  font-weight: bold;
  // line-height: 70px;
  position: relative;
  top: -10px;
}

.dialog-content {
  height: 310px;
  width: 100%;
  color: white;
}

.dialog-footer {
  height: 130px;
  width: 100%;
}

.think {
  position: absolute;
  left: 130px;
  font-size: 23px;
  text-decoration: underline;
  color: white;
}

.dialog-name {
  color: #ffcd5c !important;
  @include bg('shurukuang');
  text-align: left;
  padding-left: 20px;
}

.dialog-server {
  color: #ffcd5c !important;
  @include bg('shurukuang');
  text-align: left;
  padding-left: 20px;
  margin-top: 20px;
}

.dialog-names {
  width: 380px;
  height: 200px;
  position: relative;
  left: 70px;
}

.time {
  position: relative;
  top: 40px;
  left: 75px;
}

.order-left {
  color: white;
}

.server {
  position: relative;
  left: 180px;
  top: -8px;
  color: #958871;
}

.server-color {
  color: #ffcd5c;
  font-size: 26px;
}

.no-server {
  color: #958871;
  position: absolute;
  left: 275px;
  top: 125px;
}

.tu {
  margin: -10px 0;
}

.buy {
  color: #00336f;
}

.dingdan {
  font-size: 20px;
  text-decoration: underline;
  color: #e2c88f94;
}

footer {
  color: white;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 20px;
  height: 400px;

  p {
    margin: 5px;
  }

  h3 {
    text-align: center;
  }
}

.item {
  width: 500px;
  align-items: center;

  div {
    width: 130px;
    color: white;
  }
}

.lvtong {
  color: #ffcd5c;
}

.tips {
  font-size: 25px;
  color: white !important;
  text-align: center;
  margin-top: 30px;
}

.product_price {
  color: #eb5e5b;
  font-size: 60px;
  transform: scale(1.5);
  position: relative;
  top: 10px;
}

.back {
  color: white;
  text-decoration: underline;
  font-size: 25px;
}

.end-time {
  color: white;
  position: absolute;
  top: 665px;
}

.pay-has {
  position: absolute;
  right: 100px;
  color: white;
  text-decoration: underline;
}
</style>
